import dayjs from 'dayjs';

export function getFileExtension(filename: string): string {
  const match = filename.match(/\.([^.]+)$/);
  return match ? match[1] : '';
}

export function formatPrice(price: number, minimumFractionDigits?: number) {
  const intl = new Intl.NumberFormat('zh-CN', {
    currency: 'CNY',
    style: 'currency',
    minimumFractionDigits: minimumFractionDigits || 2,
  });

  return intl.format(price / 100);
}

export function countdownTo(endTime: string): string {
  const end = new Date(endTime).getTime();
  const now = new Date().getTime();
  const diff = Math.max(0, end - now);

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(diff / (1000 * 60 * 60)) % 24;
  const minutes = Math.floor(diff / (1000 * 60)) % 60;
  const seconds = Math.floor(diff / 1000) % 60;

  return `${days > 0 ? `${days}天 ` : ''}${hours.toString().padStart(2, '0')}小时 ${minutes.toString().padStart(2, '0')}分 ${seconds.toString().padStart(2, '0')}秒`;
}

/**
 * 计算已用时间（分钟）。
 * @returns 已用时间（分钟）
 * @param ctime
 */
export function calculateElapsedTime(ctime: string): number {
  const currentTime = dayjs();
  const creationTime = dayjs(ctime);

  // 计算已用时间（分钟）
  return currentTime.diff(creationTime, 'second');
}

/**
 * 根据进度百分比计算剩余时间。
 * @param progressPercent
 * @param ctime
 * @returns 剩余时间（分钟）
 */
export function estimateRemainingTime(
  progressPercent: number,
  ctime: string,
): number {
  const elapsedTime = calculateElapsedTime(ctime);
  // 避免除数为零的情况
  if (progressPercent === 0) {
    return Infinity; // 表示无法计算
  }

  // 如果进度百分比为 100%，则剩余时间为 0 秒
  if (progressPercent >= 100) {
    return 0;
  }

  // 总预计时间 = 已用时间 / 进度百分比
  const totalTime = elapsedTime / (progressPercent / 100);

  // 剩余时间（秒） = 总预计时间 - 已用时间
  let remainingTimeInSeconds = totalTime - elapsedTime;

  // 如果剩余时间小于 0，则将其设为 0
  if (remainingTimeInSeconds < 0) {
    remainingTimeInSeconds = 0;
  }
  return Math.ceil(remainingTimeInSeconds);
}

/**
 * 格式化秒数为分钟或小时。
 * @param seconds 秒数
 * @returns 格式化的字符串
 */
export function formatSeconds(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0) {
    return `${hours} 小时 ${minutes} 分钟`;
  } else if (minutes > 0) {
    return `${minutes} 分钟 ${remainingSeconds} 秒`;
  } else {
    return `${remainingSeconds} 秒`;
  }
}
